import { useCallback, useEffect, useState } from 'react';
import { Platform } from 'react-native';

const STORAGE_KEY = 'lesson-sidebar-expanded';

export function useLessonSidebarExpanded(defaultExpanded = true) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      setExpanded(stored === 'true');
    }
  }, []);

  const toggle = useCallback(() => {
    setExpanded((prev) => {
      const next = !prev;
      if (Platform.OS === 'web' && typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, String(next));
      }
      return next;
    });
  }, []);

  const setExpandedPersisted = useCallback((next: boolean) => {
    setExpanded(next);
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    }
  }, []);

  return { expanded, toggle, setExpanded: setExpandedPersisted };
}
